module.exports = __webpack_public_path__ + "static/media/img1@2x.98840b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/img1@2x.png
// module id = 54
// module chunks = 0